// extracted by mini-css-extract-plugin
export default {"container":"style__container--MQehR","text":"style__text--b1y1g"};